/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const DestinationStatus = zod.enum(['active', 'broken', 'disabled']);

export type DestinationStatus = zod.input<typeof DestinationStatus>;
export type DestinationStatusOutput = zod.output<typeof DestinationStatus>;
